const config = {
  API: 'https://api.bar.skypool.xyz',
  // API: process.env.NODE_ENV === 'development' ? 'http://localhost:7890': 'https://api.bar.skypool.xyz',
  adminList: ['SKYP5f96ed9dc74', 'SKYPc3130b67776', 'SKYP5f96ed9dc74']
};

export default config;
